import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=1da21614&"
import script from "./Todo.vue?vue&type=script&lang=ts&"
export * from "./Todo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports